import script from "./ContextReportColumnsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextReportColumnsTab.vue?vue&type=script&setup=true&lang=js"

import "./ContextReportColumnsTab.vue?vue&type=style&index=0&id=3c715a10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c715a10"]])

export default __exports__